module.exports = __webpack_public_path__ + "img/zanwupinglun@3x.8cf81eeb.png";